import React, { useState } from 'react'
import { AccountsLayout } from './components/layout'
import QRCode from 'assets/qr-code.png'
import { VerificationSuccess } from './components/Success'
import { VerificationError } from './components/Error'
import { Button } from 'cwp-components/forms'

const AccountVerification = () => {
  const [status, setStatus] = useState('default')
  return (
    <AccountsLayout>
      {status === 'default' && (
        <div className='relative !h-auto md:w-[900px] !m-auto md:p-[60px] p-[20px] bg-white rounded-[20px] shadow-[-0.8px_-0.8px_16px_0px_rgba(0,0,0,0.25)]'>
          <h1 className='mb-[50px] text-[#093269] md:text-[24px] text-[16px] font-bold'>
            ID verification
          </h1>
          <h3 className='mb-[20px] text-[#093269] md:text-[24px] text-[16px] '>
            Confirm your identity
          </h3>

          <div className='md:text-[16px] text-[14px] font-[400] space-y-[12px] mb-[30px] md:mb-[70px]'>
            <p>
              ID verification, by our supplier - YOTI - is to confirm your
              identity matches your profile name and regulatory record. Upon
              completion, you will receive a verified tick against your profile.
            </p>
            <p>
              YOTI will require your full name and a government-issued
              photographic ID.
            </p>
            <p>
              To start the process, click 'Continue' to be referred to our
              supplier.
            </p>
          </div>

          <div className='flex flex-wrap  items-end justify-between'>
            <img
              className='md:w-[156px] w-36  md:h-[222px]'
              src={QRCode}
              alt=''
            />
            <div className='flex gap-[10px]'>
              <Button
                onClick={() => setStatus('success')}
                className='bg-[#020251] text-white'
              >
                Continue
              </Button>
              <Button
                onClick={() => setStatus('error')}
                className='bg-red-500 text-white'
              >
                Failed
              </Button>
            </div>
          </div>
        </div>
      )}

      {status === 'success' && <VerificationSuccess setStatus={setStatus} />}
      {status === 'error' && <VerificationError setStatus={setStatus} />}
    </AccountsLayout>
  )
}

export default AccountVerification
